import { styled } from 'linaria/react';
import React from 'react';
import { useQuery } from 'react-apollo';
import CategoryLink from '@jetshop/ui/CategoryLink';
import Image from '@jetshop/ui/Image';
import SimpleCategoryHeader from '../CategoryPage/SimpleCategoryHeader';
import inspirationPosts from './InspirationPosts.gql';
import { theme } from '../Theme';

const Content = styled('div')``;
const InspirationItemsWrapper = styled('div')`
  max-width: 80rem;
  margin: auto;
  padding: 0 1.5rem;
  margin-top: 5rem;
  margin-bottom: 2rem;
  ${theme.below.lg} {
    margin-top: 2rem;
  }
`;
const CategoryList = styled('ul')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
`;
const CategoryItem = styled('li')`
  padding: 1rem 2px;
  width: 25%;

  ${theme.below.lg} {
    width: 50%;
  }

  a {
    display: block;
    text-decoration: none;
    color: black;
    text-align: center;
  }
  h2 {
    margin-top: 5px;
    font-size: 15px;
    color: black;
    font-weight: 400;
    letter-spacing: 0.03em;
    line-height: 1.3;
    max-width: 230px;
    margin: 5px auto 0 auto;
  }
  h3 {
    font-size: 12px;
    font-weight: 700;
    margin-top: 10px;
  }
`;

export const InspirationItems = ({ category, title, showLargePosts }) => {
  const { data, loading, error } = useQuery(inspirationPosts, {
    variables: {
      id: category.id
    }
  });
  if (loading || error) return null;
  return (
    <InspirationItemsWrapper>
      <CategoryList>
        {data.category.subcategories.map((category, index) => (
          <CategoryItem
            key={index}
            className={showLargePosts && index < 2 ? 'large' : 'small'}
          >
            <CategoryLink category={category}>
              <Image
                aspect={'1:1'}
                cover
                src={
                  category.images?.length > 0
                    ? category.images
                    : 'https://torshov.jetshop.se/pub_images/original/nike-daybreak.jpg'
                }
                alt={category.name}
                sizes={'600'}
              />
              <div className="category-content">
                <h3>{title}</h3>
                {showLargePosts && index < 2 ? <h2>{category.name}</h2> : null}
              </div>
            </CategoryLink>
          </CategoryItem>
        ))}
      </CategoryList>
    </InspirationItemsWrapper>
  );
};

function InspirationList(props) {
  const { category, title } = props;

  return (
    <Content>
      <SimpleCategoryHeader category={category} inspirationPage={true} />
      <InspirationItems
        title={title}
        category={category}
        showLargePosts={true}
      />
    </Content>
  );
}

export default InspirationList;
